import React from 'react';
import styled from 'styled-components';
import Button from '../../components/Button';
import Icon from '../../components/Icon';
import H1 from '../../components/H1';
import UL from '../../components/UL';
import LI from '../../components/LI';
import P from '../../components/P';
import Helmet from '../../components/Helmet';
import ResponsiveImg from '../../components/ResponsiveImg';
import NavigationLinks from '../../components/NavigationLinks';
import Contact from '../../components/Contact';
import NagMeImageHome from '../../images/nag-me.jpg';
import NagMeImageNew from '../../images/nag-me-2.jpg';
import { media } from '../../utils/style';

const NagMe = styled.article`
  p {
    margin-bottom: 25px;
  }
`;

const Header = styled.header`
  padding: 0 10px;
  text-align: center;
`;

const Buttons = styled.div`
  margin: 15px 0 35px;
`;

const ButtonsExternal = styled.div`
  margin: 15px 0;

  a {
    margin: 10px 15px;
  }
`;

const ChromeLink = styled.a`
  color: #47b346;

  &:hover,
  &:focus {
    color: #148013;
  }
`;

const FireFoxLink = styled.a`
  color: #ff9500;

  &:hover,
  &:focus {
    color: #cc6200;
  }
`;

const OperaLink = styled.a`
  color: #cc0f16;

  &:hover,
  &:focus {
    color: #990000;
  }
`;

const ContentWrapper = styled.div`
  align-content: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin-top: 0;

  ${media.desktop`
    flex-wrap: nowrap;
  `}

  ${media.giant`
    margin-top: -35px;
  `}

  ${media.ultraGiant`
    margin-top: -100px;
  `}
`;

const ContentImages = styled.div`
  margin-bottom: 35px;
  max-width: 300px;
  width: 100%;

  ${media.desktop`
    margin-bottom: 0;
    max-width: 500px;
    overflow: hidden;
    width: 27%;
  `};
`;

const GithubIcon = styled.span`
  margin-right: 10px;
`;

const ResponsiveImgWrap = styled.div`
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.35);

  ${media.desktop`
    box-shadow: -5px 0 15px rgba(0, 0, 0, .2);
    transform: ${props =>
      props.right
        ? `rotateZ(-15deg) translate(70px, 60px)`
        : `rotateZ(-15deg) translate(25px, 50px)`};
  `};
`;

const Content = styled.div`
  box-sizing: border-box;
  padding: 0 10px;
  text-align: left;
  width: 100%;

  ${media.desktop`
    align-content: center;
    display: flex;
    flex-wrap: wrap;
    padding: 0 0 0 10px;
    width: 46%;
  `};
`;

export default () => (
  <main>
    <Helmet
      title="Gowtham Selvaraj (Gauti) Project - Nag Me - Browser extension to nag users"
      description="Nag me notifies users of routine tasks. Some use cases of Nag Me are to notify to drink water, to take
    a walk, to relax your eyes and so on while you are on your computer."
      image={NagMeImageHome}
      path="/projects/nag-me"
    />
    <NagMe>
      <Header>
        <H1>Nag Me</H1>
        <P bigger>Browser extension to nag users</P>

        <ButtonsExternal>
          <UL inline>
            <LI inline>
              <ChromeLink
                href="https://chrome.google.com/webstore/detail/nag-me/jhppmbkjpboolciccfleojhinfjjdfmd"
                title="Visit Nag Me Chrome Extension Page"
                target="_blank"
                rel="noopener"
              >
                <Icon chrome /> Chrome
              </ChromeLink>
            </LI>
            <LI inline>
              <FireFoxLink
                href="https://addons.mozilla.org/en-US/firefox/addon/nag-me/"
                title="Visit Nag Me Firefox Extension Page"
                target="_blank"
                rel="noopener"
              >
                <Icon firefox /> Firefox
              </FireFoxLink>
            </LI>
            <LI inline>
              <OperaLink
                href="https://addons.opera.com/en/extensions/details/nag-me/"
                title="Visit Nag Me Opera Extension Page"
                target="_blank"
                rel="noopener"
              >
                <Icon opera /> Opera
              </OperaLink>
            </LI>
          </UL>
        </ButtonsExternal>
        <Buttons>
          <Button
            link
            bordered
            small
            href="https://github.com/gautiselvaraj/nag-me"
            title="Visit Nag Me Github Repo"
            target="_blank"
            rel="noopener"
          >
            <GithubIcon>
              <Icon github />
            </GithubIcon>
            Github
          </Button>
        </Buttons>
      </Header>

      <ContentWrapper>
        <ContentImages>
          <ResponsiveImgWrap>
            <ResponsiveImg
              src={NagMeImageHome}
              alt="Nag Me Browser Extension"
            />
          </ResponsiveImgWrap>
        </ContentImages>
        <Content>
          <P big>
            Nag me notifies users of routine tasks. Nag me notifications are
            soft (doesn't ring and auto closes) so use it for low priority tasks
            only. Some use cases of Nag Me are to notify to drink water, to take
            a walk, to relax your eyes and so on while you are on your computer.
            Nag Me works in Google Chrome, Firefox, and Opera.
          </P>
          <P big>
            I used React (Create React App), Redux, Immutable.js, Jest,
            React-Motion, and styled-components for Nag Me. I utilized
            WebExtensions API along with Mozilla's webextension-polyfill.
          </P>
          <Contact />
        </Content>
        <ContentImages>
          <ResponsiveImgWrap right>
            <ResponsiveImg
              src={NagMeImageNew}
              alt="Browser extension to notify users of routined tasks"
            />
          </ResponsiveImgWrap>
        </ContentImages>
      </ContentWrapper>
    </NagMe>

    <NavigationLinks
      prevLink="/projects/compare-movies/"
      prevCopy="Compare Movies"
      nextLink="/projects/react-shorten/"
      nextCopy="React Shorten"
    />
  </main>
);



// WEBPACK FOOTER //
// ./src/pages/projects/nag-me.js